import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";

const useIsLanguage = () => {
  const { userLanguage } = useSelector(
    ({ appData }: AppState) => ({
      userLanguage: appData.userLanguage,
    }),
    shallowEqual,
  );
  return userLanguage;
};

export default useIsLanguage;
